import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router';
import { Menu, MenuItem } from '@progress/kendo-react-layout';
import "./MainNavBar.css";
import {GridContainerFlex} from "../../../GridFlex/GridContainerFlex/GridContainerFlex.jsx";
import {MainSideDrawer} from "../MainSideDrawer/MainSideDrawer.jsx";
import {GridItemFlex} from "../../../GridFlex/GridItemFlex/GridItemFlex.jsx";
import {SCREEN_BREAKPOINTS} from "../../../../../constants/screenBreakpoints.js";
import {AppPath} from "../../../../../Router/AppRouter.jsx";

const MainNavBar = props => {
    const navigate = useNavigate();
    const [screenSize, setScreenSize] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => {
            setScreenSize(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);

        // Cleanup function to remove event listener
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const isLargerThanMd = screenSize >= SCREEN_BREAKPOINTS.md;

    // Navigation items for both menu and drawer
    let sideBarNavigationItems = [
        { text: "logout", route: "/logout" }
    ];
    const mainBarNavigationItems = [
        { text: "Home", route: "/" },
        { text: "About", route: "/about" },
        { text: "Shipment History", route: "/shipment-history" },
        { text: "Showcase", route: "/showcase" },
    ]

    if(!isLargerThanMd) {
        // combine navigation to all be in side drawer.
        sideBarNavigationItems = [
            ...sideBarNavigationItems,
            ...mainBarNavigationItems
        ]
    }

    const onSelect = event => {
        navigate(event.item.data.route);
    };

    return (
        <GridContainerFlex style={{width: "100%"}}>
            {isLargerThanMd &&
                <GridItemFlex>
                    <Menu className={"main-nav-bar"} onSelect={onSelect}>
                        <MenuItem text="Home" data={{
                            route: AppPath.home
                        }} />
                        <MenuItem text="About" data={{
                            route: AppPath.about
                        }} />
                        <MenuItem text="Shipment History" data={{
                            route: AppPath.shipmentHistory
                        }} />
                        <MenuItem text="Showcase" data={{
                            route: AppPath.showcase
                        }} />
                    </Menu>
                </GridItemFlex>
            }
            <GridItemFlex style={{flex: 1}}>
                <GridContainerFlex justifyContent={"flex-end"} style={{width: "100%"}}>
                    <GridItemFlex>
                        <MainSideDrawer navigationItems={sideBarNavigationItems} />
                    </GridItemFlex>
                </GridContainerFlex>
            </GridItemFlex>
        </GridContainerFlex>
    );
};

export default MainNavBar;